import { Tooltip as TooltipPrimitive } from '@base-ui/react/tooltip';

export type TooltipTriggerProps = TooltipPrimitive.Trigger.Props;

const TooltipTrigger = ({ ...props }: TooltipTriggerProps) => {
  return <TooltipPrimitive.Trigger data-slot="tooltip-trigger" {...props} />;
};

export default TooltipTrigger;
